import TranskipNilaiTeacher from "../../../../../components/categories/siakad/lms/data_transkip_nilai/HomeTeacher";
export default function Home() {
  
  return (
    <TranskipNilaiTeacher />
  );
}
